import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    //Largura total da tela customizado
    /* div#Content, div#ContainerPage_Content {
        max-width: calc(100% - 100px);
    } */
    :root {
        --ui-color-01: #ED961D;
        --ui-color-02: #F55414;
        --ui-color-03: #FF0F17;
        --ui-color-04: #D03080;
        --ui-color-05: #9E529F;
        --ui-color-06: #695895;
        --ui-color-07: #59708F;
        --ui-color-08: #59848F;
        --ui-color-09: #5C9076;
        --ui-color-10: #7DAA4C;
        --ui-color-11: #8f2d56;
        --ui-color-12: #f26924;
        --ui-color-13: #8B4513;
        --ui-color-14: #e85e6c;
    }

    i.material-icons {
        font-family: 'Material Icons' !important;
    }

    .color-white {
        color: var(--white) !important;
    }

    .color-black {
        color: var(--black) !important;
    }

    .bg--ui-color-white {
        background-color: var(--ui-color-01);
    }
    
    .bg--ui-color-01 {
        background-color: var(--ui-color-01);
    }
    
    .bg--ui-color-02 {
        background-color: var(--ui-color-02);
    }
    
    .bg--ui-color-03 {
        background-color: var(--ui-color-03);
    }
    
    .bg--ui-color-04 {
        background-color: var(--ui-color-04);
    }
    
    .bg--ui-color-05 {
        background-color: var(--ui-color-05);
    }
    
    .bg--ui-color-06 {
        background-color: var(--ui-color-06);
    }
    
    .bg--ui-color-07 {
        background-color: var(--ui-color-07);
    }
    
    .bg--ui-color-08 {
        background-color: var(--ui-color-08);
    }
    
    .bg--ui-color-09 {
        background-color: var(--ui-color-09);
    }
    
    .bg--ui-color-10 {
        background-color: var(--ui-color-10);
    }
    
    .bg--ui-color-11 {
        background-color: var(--ui-color-11);
    }
    
    .bg--ui-color-12 {
        background-color: var(--ui-color-12);
    }
    
    .bg--ui-color-13 {
        background-color: var(--ui-color-13);
    }
    
    .bg--ui-color-14 {
        background-color: var(--ui-color-14);
    }
    
    .bg-hover--ui-color-01:hover {
        background-color: var(--ui-color-01);
    }
    
    .bg-hover--ui-color-02:hover  {
        background-color: var(--ui-color-02);
    }
    
    .bg-hover--ui-color-03:hover  {
        background-color: var(--ui-color-03);
    }
    
    .bg-hover--ui-color-04:hover  {
        background-color: var(--ui-color-04);
    }
    
    .bg-hover--ui-color-05:hover  {
        background-color: var(--ui-color-05);
    }
    
    .bg-hover--ui-color-06:hover  {
        background-color: var(--ui-color-06);
    }
    
    .bg-hover--ui-color-07:hover  {
        background-color: var(--ui-color-07);
    }
    
    .bg-hover--ui-color-08:hover  {
        background-color: var(--ui-color-08);
    }
    
    .bg-hover--ui-color-09:hover  {
        background-color: var(--ui-color-09);
    }
    
    .bg-hover--ui-color-10:hover  {
        background-color: var(--ui-color-10);
    }
    
    .bg-hover--ui-color-11:hover  {
        background-color: var(--ui-color-11);
    }
    
    .bg-hover--ui-color-12:hover  {
        background-color: var(--ui-color-12);
    }
    
    .bg-hover--ui-color-13:hover  {
        background-color: var(--ui-color-13);
    }
    
    .bg-hover--ui-color-14:hover  {
        background-color: var(--ui-color-14);
    }
    
    .border--ui-color-01 {
        border-color: var(--ui-color-01);
    }
    
    .border--ui-color-02 {
        border-color: var(--ui-color-02);
    }
    
    .border--ui-color-03 {
        border-color: var(--ui-color-03);
    }
    
    .border--ui-color-04 {
        border-color: var(--ui-color-04);
    }
    
    .border--ui-color-05 {
        border-color: var(--ui-color-05);
    }
    
    .border--ui-color-06 {
        border-color: var(--ui-color-06);
    }
    
    .border--ui-color-07 {
        border-color: var(--ui-color-07);
    }
    
    .border--ui-color-08 {
        border-color: var(--ui-color-08);
    }
    
    .border--ui-color-09 {
        border-color: var(--ui-color-09);
    }
    
    .border--ui-color-10 {
        border-color: var(--ui-color-10);
    }
    
    .border--ui-color-11 {
        border-color: var(--ui-color-11);
    }
    
    .border--ui-color-12 {
        border-color: var(--ui-color-12);
    }
    
    .border--ui-color-13 {
        border-color: var(--ui-color-13);
    }
    
    .border--ui-color-14 {
        border-color: var(--ui-color-14);
    }
    
    .color--ui-color-01 {
        color: var(--ui-color-01);
    }
    
    .color--ui-color-02 {
        color: var(--ui-color-02);
    }
    
    .color--ui-color-03 {
        color: var(--ui-color-03);
    }
    
    .color--ui-color-04 {
        color: var(--ui-color-04);
    }
    
    .color--ui-color-05 {
        color: var(--ui-color-05);
    }
    
    .color--ui-color-06 {
        color: var(--ui-color-06);
    }
    
    .color--ui-color-07 {
        color: var(--ui-color-07);
    }
    
    .color--ui-color-08 {
        color: var(--ui-color-08);
    }
    
    .color--ui-color-09 {
        color: var(--ui-color-09);
    }
    
    .color--ui-color-10 {
        color: var(--ui-color-10);
    }
    
    .color--ui-color-11 {
        color: var(--ui-color-11);
    }
    
    .color--ui-color-12 {
        color: var(--ui-color-12);
    }
    
    .color--ui-color-13 {
        color: var(--ui-color-13);
    }
    
    .color--ui-color-14 {
        color: var(--ui-color-14);
    }
    
    .color-hover--ui-white:hover  {
        color:  #ffffff;
    }

    .btn-circle {
        width: 42px;
        height: 42px;
        min-width: 42px;
        padding: 0;
        border-radius: 100%;
        font-size: 18px;

        svg {
            font-size: 18px;
        }
    }

    .btn-acao-oficio {
        padding: 0px !important;
        margin: 0;
        line-height: 0 !important;
        letter-spacing: 0 !important;
        border-radius: 100% !important;
        border: 2px solid;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        min-width: 32px !important;
        min-height: 32px !important;
        transition: all 0.35s ease-in-out;
    }

    .btn-fixado-oficio {
        color: #fff !important;
        background-color: var(--alternative6) !important;
        border-color: var(--alternative6) !important;
    }

    .btn-fixado-oficio.fixado {
        background-color: #fff !important;
        color: var(--yellow) !important;
        border-color: var(--yellow) !important;
    }

    .btn-editar-oficio,
    .btn-resposta-oficio {
        background-color: #fff !important;
        color: var(--ui-color-12) !important;
        border-color: var(--ui-color-12) !important;
    }

    .btn-tramite-interno {
        background-color: #fff !important;
        color: var(--ui-color-05) !important;
        border-color: var(--ui-color-05) !important;
    }

    .btn-anexar-documento {
        background-color: #fff !important;
        color: var(--ui-color-09)!important;
        border-color: var(--ui-color-09)!important;
    }

    .btn-configuracao-oficio {
        background-color: #fff !important;
        color: var(--ui-color-07) !important;
        border-color: var(--ui-color-07) !important;
    }

    .btn-assina-oficio {
        background-color: #fff !important;
        color: var(--dark) !important;
        border-color: var(--dark) !important;
    }

    .btn-assinapresidente-oficio {
        background-color: #fff !important;
        color: var(--orange) !important;
        border-color: var(--orange) !important;
    }

    .btn-juntada-oficio {
        background-color: #fff !important;
        color: var(--gray) !important;
        border-color: var(--gray) !important;
    }

    .btn-oficio-lixeira,
    .btn-oficio-undo {
        background-color: #fff !important;
        color: var(--red) !important;
        border-color: var(--red) !important;
    }   

    .btn-oficio-recibo,
    .btn-oficio-recurso {
        background-color: #fff !important;
        color: var(--ui-color-13) !important;
        border-color: var(--ui-color-13) !important;
    } 

    .btn-oficio-enviar,
    .btn-oficio-criar {
        background-color: #fff !important;
        color: var(--ui-color-10) !important;        
        border-color: var(--ui-color-10) !important;        
    }

    .btn-oficio-reverter {
        background-color: #fff !important;
        color: var(--ui-color-02) !important;        
        border-color: var(--ui-color-02) !important;        
    }    

    .btn-salvar-default {
        height: 36.5px;
        width: 93px;

        svg {
            color: var(--white);
        }
    }

    div#FloatAction {
        background: var(--primary);
        width: max-content;
        position: absolute;
        right: 1px;
        opacity: 0;
        transition: all ease .35s;
        color: var(--white);
        padding: 5px 15px;
        border-radius: 100px;
    }

    ul.menu-btn li {
        position: relative;
    }

    ul.menu-btn li:hover div#FloatAction {
        right: 52px;
        opacity: 1;
    }

    .loading-btn-acao-oficio svg {
        color: var(--black);
    }

    span#skeleton-default-input {
        height: 32px;
        width: 100%;
        position: relative;
        transform: scale(1);
    }

    span.MuiButtonBase-root.MuiIconButton-root.PrivateSwitchBase-root-25.MuiCheckbox-root.MuiCheckbox-colorSecondary.check-oficio.MuiIconButton-colorSecondary {
        /* max-width: 0px; */
        border-radius: 0;
    }
    
    .error-form-helper-text {
        color: var(--red);
    }

    #dialog-padrao .MuiPaper-root.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.MuiPaper-rounded {
        max-width: 1024px !important;
        width: 100%;
    }

    div#dialog-crud-assunto .MuiPaper-root.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm {
        max-width: 850px !important;
        width: 100%;
    }

    div#dialog-crud-assunto .MuiPaper-root.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm .MuiDialogContent-root {
        padding: 23px;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.bg-primario.txt-branco.btn-salvar-default.btn-excluir-default {
        background: var(--red) !important;
    }

    div#Notification {
        display: none !important;
    }

    .MuiFormControl-root {
        width: 100%;
    }

    fieldset.MuiOutlinedInput-notchedOutline legend{
        max-width: 0 !important;
    }

    .multiline-textfield-with-chips .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl.MuiInputBase-multiline.MuiOutlinedInput-multiline.MuiInputBase-adornedStart.MuiOutlinedInput-adornedStart {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .MuiFormControl-root.MuiTextField-root.MuiFormControl-marginNormal {
        margin-top: 0 !important;
    }

    .MuiFormControl-root.MuiTextField-root.multiline-textfield-with-chips textarea#outlined-multiline-flexible {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 0 0 0 10px;
    }

    div#textfield-with-chips {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 6px;
    }

    .MuiFormControl-root.MuiTextField-root.multiline-textfield-with-chips textarea#outlined-multiline-flexible {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 0 0 0 10px;
    }

    div#textfield-with-chips .MuiChip-root.chip-item-textfield-with.MuiChip-deletable {
        background: var(--primary);
        color: var(--white);
    }

    div#textfield-with-chips .MuiChip-root.chip-item-textfield-with.MuiChip-deletable svg {
        color: var(--white);
    }

    .MuiChip-root.chip-item-textfield-with.MuiChip-deletable span.MuiChip-label {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .MuiDialogActions-root.MuiDialogActions-spacing {
        padding: 20px;
    }

    div#alert-dialog-slide-title h2 {
        font-size: 2rem;
    }

    .header-error-modal-fetch {
        background: var(--ui-color-14);
    }

    .header-error-modal-fetch h2, .header-error-modal-fetch h2 span {
        color: var(--white);
    }

    span.icon-error-header-data-fetch {
        border: 2px solid;
        border-radius: 100%;
        width: 42px;
        height: 42px;
        min-width: 0;
        min-height: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 10px 0 0;
    }

    .header-error-modal-fetch h2 {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    p#alert-dialog-slide-description {
        font-weight: 400;
        font-size: 1.5rem;
        margin: 10px 0 0 0;
    }

    pre#code-area {
        word-break: break-all;
        overflow: auto;
    }

    .button-error-modal-fetch {
        background: var(--ui-color-14) !important;
        color: var(--white) !important;
    }

    div#alert-dialog-error-fetch .MuiPaper-root.MuiDialog-paper {
        width: 100%;
    }

    button#btn-popover-filter-search-bar {
        position: absolute;
        overflow: visible;
        height: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: end;
        max-width: 610px;
        width: 100%;
        top: 26px !important;
        border-radius: 10px;
        border: 0;
        background: transparent;
        margin: 0;
    }

    button#btn-inside-popover-filter-search-bar {
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 0%);
        min-width: 0;
        padding: 0;
        width: 36px;
        height: 36px;
        border-radius: 100%;
        right: 13px;
        background: var(--white) !important;
        color: var(--black) !important;
    }

    div#filter-search-bar .MuiPaper-root.MuiPaper-rounded {
        max-width: 610px;
        width: 100%;
        top: 60px !important;
        border-radius: 10px;
    }

    .switch-label-filters {
        display: flex;
        align-items: center;
    }

    .switch-label-filters span.description-switch-label-filter {
        font-weight: normal;
        font-size: 13px;
        text-align: left;
    }

    .action-search-filters-poopover {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 20px;
        margin: 25px 0 0 0;    
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-send-search-filters {
        background: linear-gradient(189deg,rgb(23,126,201) 0%,rgb(38,71,184) 100%);
        color: var(--white);
        min-width: 0;
        padding: 8px 16px;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-clear-search-filters {
        background: linear-gradient(189deg,rgb(195 195 195) 0%,rgb(68 68 68) 100%);
        color: var(--white);
        min-width: 0;
        padding: 8px 16px;
    }

    .form-switch input:checked+i {
        background: var(--primary);
    }

    /* pdf viewer custom css */
    .columns.is-gapless.box.is-mobile.has-text-white.has-background-black {
        background: #323639;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }

    .container.text-center div:nth-child(2n)>div>div:nth-child(2n) {
        background: #aaaaaa;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        overflow: auto;
    }

    .column.buttons.are-small.has-addons {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    button.button.is-black.is-marginless {
        border: 0;
        border-radius: 100%;
        min-width: 0;
        min-height: 0;
        width: 32px;
        height: 32px;
        padding: 0;
        background: transparent;
        color: #fff;
        image-rendering: -webkit-optimize-contrast;
        transition: all ease .35s;
        cursor: pointer;
    }

    button.button.is-black.is-marginless[disabled] {
        background: transparent;
        color: grey;
        cursor: inherit;
    }

    button.button.is-black.is-marginless span {
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    button.button.is-black.is-marginless:hover {
        background: #636363;
        transition: all ease .35s;
    }

    button.button.is-black.is-marginless[disabled]:hover {
        background: transparent !important;
        color: grey !important;
    }

    .column.is-3.buttons.are-small.has-addons.is-centered span.is-vcentered.has-text-centered.is-inline-flex.button.is-black.is-marginless {
        color: #fff;
    }

    .container.text-center div:nth-child(2n)>div>div:nth-child(2n)>div {
        overflow: auto;
        padding: 10px;
    }

    .container.text-center div:nth-child(2n)>div>div:nth-child(2n)>div>div {
        height: auto !important;
        max-height: 1200px;
    }

    .col-download-pdf-viewer {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        margin: 0 0 10px 0;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-download-pdf-viewer {
        background: var(--primary);
        color: var(--white);
        text-transform: capitalize;
        width: 160px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-download-pdf-viewer span.MuiButton-label {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ul.list-of-errors {
        padding: 0;
        list-style: inside;
        padding: 0 10px;
    }

    /* #notification-menu .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {
        min-height: 282px;
    }

    #notification-menu li.content-subitem-menu-notifications {
        height: 224px !important;
    } */

    .MuiPaper-root.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.MuiPaper-rounded {
        max-width: 1200px;        

        #paper-card {
            padding: 20px;
            margin: 50px 0 0 0;
            border-radius: 10px;
            border-left: 4px solid var(--secondary);
        }
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-visualizar-oficio {        
        background: #3A85AD;
        border: 2px solid #3A85AD;        
        color: #ffffff;
        padding: 4px 10px;
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.btn-visualizar-oficio span.MuiButton-label {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .accordion-respostas-oficio-details-dados-oficio div#DadosOficio_Resposta {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
    }

    .accordion-respostas-oficio-details-dados-oficio div#DadosOficio_List {
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    .accordion-respostas-oficio-details-dados-oficio div#DadosOficio_Respostas {
        margin: 0;
    }

    .accordion-respostas-oficio-details-dados-oficio  .acoes-respostas-oficios {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    btn-download-anexo-item-oficio:disabled{
        background:  #fff !important;
        color: #ccc !important;
        cursor: no-drop !important;
    }

    .OficioBox_Loading {
        div#OficioBox_InfoInicial {
            padding: 12px !important;
            gap: 16px !important;
            width: 112px !important;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root.OficioBox_AccordionSummary {
            width: calc(100% - 136px) !important;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root.OficioBox_AccordionSummary .MuiAccordionSummary-content {
            width: 100%;
        }

        .MuiPaper-root.MuiAccordion-root.MuiAccordion-rounded.MuiPaper-elevation1.MuiPaper-rounded {
            box-shadow: 0px 2px 1px -1px rgba(0,0,0,0), 0px 1px 1px 0px rgba(0,0,0,0), 0px 1px 3px 0px rgba(0,0,0,0) !important;
        }
    }

    button.MuiButtonBase-root.MuiButton-root.MuiButton-text.bg-primario.txt-branco.btn-salvar-default.btn-excluir-default {
        background: var(--red) !important;
    }
`